import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

const RESOURCE = `${API_URL}/users`;

getMergeStats.operation = 'READ';
getMergeStats.byId = true;

export function getMergeStats(userId) {
    return get(`${RESOURCE}/${userId}/merge-stats`);
}
